import styled from 'styled-components';

import { Paragraph } from '@vimeo/iris/typography';

import { breakpoints } from './constants';

interface GradientProps {
  color: string;
}

export const Gradient = styled.div<GradientProps>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: -1;
  background: ${(props) => `linear-gradient(to bottom, ${props.color} 50%, #fff 100%)`};

  @media (min-width: ${breakpoints.mobile}) {
    height: 200vh;
  }
`;

export const PageWrapper = styled.div<{ topOffset?: number }>`
    width: 100%;
    overflow: hidden;
    padding-top: ${(props) => (props.topOffset ? props.topOffset + 70 + 'px' : '70px')}};

    @media (min-width: ${breakpoints.tablet}) {
        padding-top: 90px;
    }

    @media (min-width: ${breakpoints.standardTablet}) {
        padding-top: ${(props) => (props.topOffset ? props.topOffset + 90 + 'px' : '90px')}};
    }
`;

export const Title = styled(Paragraph)`
  color: #fff;
  margin-bottom: unset;
`;

export const Description = styled(Paragraph)`
  color: #fff;
  opacity: 0.5;
`;

export const Texture = styled.img`
  position: absolute;
  width: 66.6%;
  max-width: 250px;
  left: -67px;
  top: 0;
  z-index: -1;
  @media (min-width: ${breakpoints.tablet}) {
    width: 70.72%;
    max-width: 500px;
    left: -125px;
  }
  @media (min-width: ${breakpoints.desktop}) {
    left: 0;
    width: 76%;
    max-width: 600px;
  }
  @media (min-width: ${breakpoints.XLDesktop}) {
    max-width: 785px;
    top: auto;
    bottom: 0;
  }
`;

export const TextureWrapper = styled.div`
    img:first-child {
        height: calc((100vw - 40px) * (480 / 857) + 150px); /* proportional to the second image */

        @media (min-width: ${breakpoints.tablet}) {
            height: calc((100vw - 68px) * (480 / 857) + 150px); /* proportional to the second image */
            max-height: 654px;
        }

        @media (min-width: ${breakpoints.desktop}) {
            height: 100%;
        }
    }

    img:nth-child(2) {
        padding-top: 75px;
        max-width: 100%;

        @media (min-width: ${breakpoints.desktop}) {
            padding-bottom: 75px;
        }
`;
